var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03868608,3.06726912 C6.03868608,4.70834197 4.70834197,6.03868608 3.06726912,6.03868608 C1.42619627,6.03868608 0.09585216,4.70834197 0.09585216,3.06726912 C0.09585216,1.42619627 1.42619627,0.09585216 3.06726912,0.09585216 C4.70834197,0.09585216 6.03868608,1.42619627 6.03868608,3.06726912 Z M2.72356724,4.64061044 L4.92816692,2.43601076 C5.00302745,2.36115022 5.00302745,2.23976544 4.92816692,2.1649049 L4.65706106,1.89379905 C4.58220053,1.81892653 4.46081575,1.81892653 4.38594323,1.89379905 L2.58800832,3.69172198 L1.74859501,2.85230867 C1.67373447,2.77744813 1.55234969,2.77744813 1.47747718,2.85230867 L1.20637132,3.12341452 C1.13151079,3.19827506 1.13151079,3.31965984 1.20637132,3.39452038 L2.4524494,4.64059846 C2.52732192,4.71547097 2.64869472,4.71547097 2.72356724,4.64061044 L2.72356724,4.64061044 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.c94cdf99dff89ec8840d47b216ce0493.svg";
export { ForwardRef as ReactComponent };